import type { ScreenChoice, ScreenPickerRequest } from '@novachat/shared';
import { create } from 'zustand';
import { desktop } from '../lib/desktop';

/** The desktop app's question "which screen or window?" (browsers show their own picker instead). */
export const useScreenPicker = create<{ request: ScreenPickerRequest | null }>()(() => ({ request: null }));

let cancelled = false;

/** Starts listening; returns the function that stops. A newer question replaces an open one. */
export function listenForScreenPicker() {
  return desktop?.onScreenPicker?.((request) => useScreenPicker.setState({ request }));
}

/** `null`: the user closed the picker without sharing. */
export function answerScreenPicker(choice: ScreenChoice | null) {
  const { request } = useScreenPicker.getState();
  if (!request) return;
  cancelled = choice === null;
  useScreenPicker.setState({ request: null });
  desktop?.chooseScreen?.(request.id, choice);
}

/** True once after the user gave up in the picker: sharing failed on purpose, nothing to report. */
export function takeScreenPickerCancel(): boolean {
  const was = cancelled;
  cancelled = false;
  return was;
}
